/**
 * Call `cb` once, the first time `el` scrolls into view, then stop observing.
 *
 * Degrades to an immediate call when IntersectionObserver is unavailable, so
 * progressive enhancements built on top of it never leave content in their
 * pre-animation state.
 *
 * @returns a cleanup function that cancels the pending observation.
 */
export function observeOnce(el, cb, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.rootMargin, rootMargin = _c === void 0 ? '0px 0px -15% 0px' : _c, _d = _b.threshold, threshold = _d === void 0 ? 0 : _d;
    if (typeof IntersectionObserver === 'undefined') {
        cb(el);
        return function () { };
    }
    var observer = new IntersectionObserver(function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (!entry.isIntersecting) {
                continue;
            }
            observer.disconnect();
            cb(entry.target);
            return;
        }
    }, { rootMargin: rootMargin, threshold: threshold });
    observer.observe(el);
    return function () { return observer.disconnect(); };
}
